import { Link } from "react-router-dom";
import { provideLocationState } from "components/utility/hoc/LocationState";

var CurrentUser = require("lib/account/CurrentUser");
var OrgTypes = require("lib/academic/OrgTypes");

var Spinner = require("components/utility/Spinner");
var DataClassActivity = require("components/data/org_reports/DataClassActivity");
var DataSchoolActivity = require("components/data/org_reports/DataSchoolActivity");
var DateSpanSelector = require("components/data/DateSpanSelector");
var DownloadDataLink = require("components/data/DownloadDataLink");
var OrgDropdown = require("components/org/OrgDropdown");

var OrgActivityRouting = require("lib/routing/OrgActivityRouting");

require("users/admins/admin_home_page");

@provideLocationState(OrgActivityRouting.getRouteState)
class AdminHomePage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onChangeView(change) {
		$wr.redirect(OrgActivityRouting.getPath({ 
			...this.props.locationState, ...change
		}));
	}

	selectDates(startDate, endDate) {
		this.onChangeView({ startDate, endDate });
	}

	onOrgSelect(orgIdentifier) {
		this.onChangeView({ orgIdentifier });
	}
	onClick(){
	}

	render () {
		var { startDate, endDate, orgIdentifier } = this.props.locationState;

		var vk = $wr.sortedJSON(this.props.locationState);

		if (this.props.adminOrgLevel === OrgTypes.DISTRICT_ORG) {
			orgIdentifier = orgIdentifier || OrgTypes.ALL_SCHOOL_ORGS;

			var headerText = "District Admin Dashboard";
			if (OrgTypes.isSchoolOrgIdentifier(orgIdentifier)) {
				var report = (
					<DataClassActivity startDate={ startDate } endDate={ endDate }
						schoolOrgID={ parseInt(OrgTypes.fromIdentifier(orgIdentifier).key) }
						onChangeView={ this.onChangeView } />
				);
			} else if (orgIdentifier === OrgTypes.ALL_STUDENT_LISTS_IDENTIFIER) {
				var report = (
					<DataClassActivity startDate={ startDate } endDate={ endDate }
						onChangeView={ this.onChangeView } />
				);
			} else {
				var report = (
					<DataSchoolActivity startDate={ startDate } endDate={ endDate }
						onChangeView={ this.onChangeView } />
				);
			}

			var orgDropdown = (
				<OrgDropdown dropdownDisplay="link" 
					selectedIdentifier={ orgIdentifier }
					selectionTypes={ [OrgTypes.ALL_SCHOOL_ORGS, OrgTypes.ALL_STUDENT_LISTS, OrgTypes.SCHOOL_ORG] }
					onSelect={ this.onOrgSelect }  />
			);

			var setupProgressLink = (
				<span>
					<Link to={"/settings/code-table"} onClick={this.onClick}> 
						View your district's setup progress
					</Link>
				</span>
			)
		} else {
			orgIdentifier = orgIdentifier || OrgTypes.ALL_STUDENT_LISTS;
			var headerText = "School Admin Dashboard";

			var report = (
				<DataClassActivity startDate={ startDate } endDate={ endDate }
					onChangeView={ this.onChangeView } />
			);
			var setupProgressLink = (
				<span>
					<Link to={"/settings/code-table"} onClick={this.onClick}> 
						View your school's setup progress
					</Link>
				</span>
			)
		}

		return (
			<div className="container adminHomePage">
				<header className="pageHeader hideOnPrint">
					<h1>{ headerText }</h1>
					<div className="setupLink"> {setupProgressLink}</div>
				</header>

				<div className="controlBox">
					{ orgDropdown }
					<DateSpanSelector onSelectDates={ this.selectDates }
						expectationsSpans={ [] }
						startDate={ startDate } endDate={ endDate } />
					<DownloadDataLink startDate={ startDate } endDate={ endDate }
						orgIdentifier={ orgIdentifier } />
				</div>
				<div key={ vk }>
					{ report }
				</div>
			</div>
		)
	}
};

AdminHomePage.WrappedComponent.propTypes = PageStrictPropTypes({
	locationState: PropTypes.object.isRequired,
	adminOrgLevel: PropTypes.string.isRequired
});

module.exports = AdminHomePage;



// WEBPACK FOOTER //
// ./modules/components/users/admins/AdminHomePage.js